const hostname = window.location.hostname.toLowerCase();

const isJuhlapesuHostname = hostname.includes('juhlapesu');
const isJuhlapesuBrandEnv = process.env.REACT_APP_BRAND === 'juhlapesu';

export const isJuhlapesu = isJuhlapesuHostname || isJuhlapesuBrandEnv;
export const isGlimra = !isJuhlapesu;
